import { render, staticRenderFns } from "./best-ranking-podium.component.vue?vue&type=template&id=185c82b3&scoped=true"
import script from "./best-ranking-podium.component.vue?vue&type=script&lang=js"
export * from "./best-ranking-podium.component.vue?vue&type=script&lang=js"
import style0 from "./best-ranking-podium.component.vue?vue&type=style&index=0&id=185c82b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c82b3",
  null
  
)

export default component.exports